<accredible-carousel-multi
  *transloco="let t; read: 'trending-courses'"
  titleFontClass="font-h-extrabold"
  [class.ghost]="isLoading()"
  [title]="t('trending_courses')"
  [customOptions]="options">
  @for (course of courses(); track course.id) {
    <accredible-carousel-item>
      <accredible-tile [hasHover]="true" [class.featured]="course.recommendation_featured">
        <a
          id="trkCourseTrending"
          target="_blank"
          [class.is-tablet-or-mobile]="isTabletOrMobile"
          [attr.aria-label]="
            t('aria_course_link', { courseName: course.course_name, issuer: course.issuer.name })
          "
          [href]="course.tracked_click_link">
          <div class="appearance-container">
            <div
              [class.certificate-and-badge]="course.certificate_design && course.badge_design"
              [class.only-certificate]="course.certificate_design && !course.badge_design"
              class="appearance-wrapper">
              <accredible-credential-appearance
                [group]="course.partialCredential.group"
                [partialCredential]="course.partialCredential"
                [showLabel]="false" />
            </div>
          </div>

          <div class="course-info">
            <div class="issuer">
              <div class="issuer-img">
                <img [src]="course.issuer.logo_url" alt="" />
              </div>
              <div class="issuer-name">{{ course.issuer.name }}</div>
            </div>

            <div class="name-featured-container">
              <div class="name font-l-semibold">
                {{ course.course_name }}
              </div>

              @if (course.recommendation_featured) {
                <cf-featured />
              }
            </div>

            @if (course.learning_outcomes.length > 0) {
              <div class="skills">
                <span>{{ t('skills') }}</span>

                @for (
                  skill of course.learning_outcomes | slice: 0 : 2;
                  track skill;
                  let isLast = $last
                ) {
                  <span>
                    {{ skill }}
                    @if (!isLast) {
                      -
                    }
                  </span>
                }
              </div>
            }
          </div>

          <div class="actions">
            <cf-share [isLoading]="isLoading()" [course]="course" />
            <div class="actions-divider"></div>
            <cf-favorite [isLoading]="isLoading()" [course]="course" />
          </div>
        </a>
      </accredible-tile>
    </accredible-carousel-item>
  }
</accredible-carousel-multi>
